import React from "react";

const ChecklistDemoGroup = ({ value, brandDemographic, selectedBrandDemographics, onClick }) => {
  const isChecked = (demoGroupValueBindings) => {
    const selectedDemos = selectedBrandDemographics
      .filter((demo) => demo.demographicId === brandDemographic.demographicId)[0]
      .brandDemos.map((brandDemo) => brandDemo.demographicValueId);
    return demoGroupValueBindings.every((id) => selectedDemos.includes(id));
  };
  return (
    <button
      className={`checklist-demo-group-btn ${isChecked(value.demoGroupValueBindings) ? "is-checked" : ""}`}
      type="button"
      onClick={onClick}
    >
      {value.name}
    </button>
  );
};

export default ChecklistDemoGroup;
